import { SelectItemInterface } from "../interface/SelectItemInterface";
import { getLocale } from "../services/Locale";

export const GetListSelect = (
  listFR: SelectItemInterface[],
  listEN: SelectItemInterface[],
): any => {
  const locale = getLocale();
  const list: SelectItemInterface[] =
    locale === "en-US" || locale === "en" ? listEN : listFR;
  if (list?.length) {
    return sortList(list);
  }
  return list;
};

export const sortList = (list: any[]) => {
  if (list?.length) {
    list?.sort(function (a: SelectItemInterface, b: SelectItemInterface) {
      return a?.label.localeCompare(b?.label);
    });
  }
  return list;
};
